// extracted by mini-css-extract-plugin
export default {"radio-button-text-color":"PositionCodeAssign_radio-button-text-color__gH-OX","position-code-asign-wrapper":"PositionCodeAssign_position-code-asign-wrapper__rE6wH"};